import { EyeOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Tag, Typography, Tooltip } from "antd";
import { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { handleSetIsShowAdvertPreview } from "../ListItems/ClientStates";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import Favorite from "./Favorite";
import NoImageSmall from "assets/Images/no_image_card.webp";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import AdvertOptions from "./AdvertOptions";
import { useNavigate } from "react-router-dom";
interface ListItemCarouselIndexProps {
  item: any;
  pageType?: string;
  viewType?: string;
  mainItem?: any;
  data?: any;
  setData?: any;
}

const CardItemCarouselIndex: FC<ListItemCarouselIndexProps> = (props) => {
  const { viewingModes } = useSelector((state: RootState) => state.realState);
  const dispatch = useDispatch();
  const swiperRef = useRef<any>(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [hasMultipleSlides, setHasMultipleSlides] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [isPreviewHovered, setIsPreviewHovered] = useState(false);

  const navigate = useNavigate();

  const { Text } = Typography;

  const getRelativeDate = (updateDate: string) => {
    const today = dayjs().startOf("day");
    const updated = dayjs(updateDate).startOf("day");
    const diffInDays = today.diff(updated, "day");
    return diffInDays;
  };

  useEffect(() => {
    if (props.item.advertMedia.length > 1) {
      setHasMultipleSlides(true);
    } else {
      setHasMultipleSlides(false);
    }
  }, [props.item.advertMedia]);

  const handleSlideChange = () => {
    if (swiperRef.current) {
      setIsBeginning(swiperRef.current.swiper.isBeginning);
      setIsEnd(swiperRef.current.swiper.isEnd);
    }
  };

  const location = `${props.item?.neighbourhood?.name || ""} ${props.item?.district?.name || ""
    } ${props.item?.city?.name || ""}`;

  let options = props.item?.cardViewAdvertOptions || "{}";
  let optionType = props.item.type || 1;
  let parsedOptions: Record<string, any> = {};

  try {
    parsedOptions = JSON.parse(options);
    // console.log("Parsed Options:", parsedOptions);
  } catch {
    return <Text>JSON valid değil</Text>;
  }

  const priorityKeys = optionType === 1 ? ["m²", "Kat Sayısı", "Oda Sayısı"] : ["Yıl", "KM", "Renk"];

  const isBoldFontColored = props.item?.dopingList?.find((item: any) =>
    item?.id === 10
  );

  const formatValue = (key: string, value: any) => {
    const normalizedValue = String(value).trim().toLowerCase();

    if (["evet", "hayır", "hayir"].includes(normalizedValue)) {
      return key;
    }

    if (key.toLowerCase().includes("km")) {
      return `${value} Km`;
    }

    if (key.includes("m²")) {
      return `${key.match(/\((.*?)\)/)?.[1]} ${value} m²`;
    }

    return key;
  };

  // console.log("View Type:", props.viewType);

  return (
    <>
      <div className="group">
        {props.item.advertMedia?.length > 0 ? (
          <>
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              modules={[Navigation]}
              ref={swiperRef}
              onSlideChange={handleSlideChange}
              onInit={handleSlideChange}
              className={`!w-full group  ${props.viewType === "card"
                ? "!h-[150px] md:!h-[230px]"
                : "!h-[150px]"
                }`}
            >
              {props.item.advertMedia.map((item: any) => {
                return (
                  <SwiperSlide
                    className={`relative group overflow-hidden 
                    ${props.pageType === "showcase"
                        ? "rounded-tl-md rounded-tr-md"
                        : "!rounded-md"
                      } 
                    !w-full ${props.viewType === "card"
                        ? "!h-[160px]  md:!h-[230px]"
                        : "!h-[150px]"
                      }`}
                  >
                    <LazyLoadImage
                      wrapperHeight="100%"
                      wrapperWidth="100%"
                      src={
                        item?.media?.fullPath
                          ? `${setBackEndUlr()}/${item?.media?.fullPath}`
                          : NoImageSmall
                      }
                      imageClassName={`w-full h-full !object-cover transition-opacity duration-300  ${props.pageType === "showcase"
                        ? "rounded-tl-md rounded-tr-md"
                        : "!rounded-md"
                        }`}
                      alt="Advert"
                    />

                    <div className="absolute inset-0 bg-black opacity-0  transition-opacity duration-300"></div>

                    {(() => {
                      if (props.pageType === "portfolio") {
                        return <></>;
                      }
                      return (
                        <>
                          <Favorite
                            item={props.item}
                            pageType={props.pageType}
                            viewType={props.viewType}
                            mainItem={props.mainItem}
                            data={props.data}
                            setData={props.setData}
                          />

                          <span
                            className={`absolute top-1 sm:top-2 ${props.viewType !== "list"
                              ? "!left-1 md:!left-4"
                              : "!right-1 md:!right-4"
                              } !text-[#ffc600]`}
                          >
                            <Tag
                              color="#dce8ff"
                              className={`!m-0 !text-black !text-[10px] md!text-base ${props.viewType === "list"
                                ? "!w-15 !text-[10px]"
                                : ""
                                }`}
                            >
                              {(() => {
                                return "";
                              })()}
                              {getRelativeDate(props.item.insertDate) ===
                                0
                                ? "Bugün"
                                : `${getRelativeDate(
                                  props.item.insertDate
                                )} Gün Önce`}
                            </Tag>
                          </span>

                          {/* Önizleme butonu - Gün önce tagının altında */}
                          <div
                            className={`absolute ${props.viewType === "list"
                              ? "top-12 right-1 md:right-4"
                              : "top-12 left-1 md:left-4"
                              } flex gap-2 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300`}
                          >
                            <div
                              onClick={async (e) => {
  e.preventDefault();
  e.stopPropagation();
  navigate(`/?id=${props.item.id}`, { replace: false });
  dispatch(handleSetIsShowAdvertPreview({ status: true }));
}}
                              className="cursor-pointer"
                            >
                              <Tag
                                className="!m-0 !text-white !text-[10px] md!text-base"
                                color="black"
                              >
                                <span style={{ zIndex: 9999 }}>
                                  <EyeOutlined />
                                  <span className="!hidden md:!inline"> Ön İzleme</span>
                                </span>
                              </Tag>
                            </div>
                          </div>

                          {/* Özellik tagları - Artık kaybolmayacak */}
                          <span className={`absolute bottom-4 flex gap-[4px] ${props.viewType !== "list"
                            ? "!left-1 md:!left-4"
                            : "hidden"
                            } !text-[#ffc600] opacity-100 transition-opacity duration-300`}>
                            {(() => {
                              try {
                                const raw = props?.item?.advertOptionAttr;
                                let arrayData: any[] = [];

                                if (typeof raw === "string") {
                                  arrayData = JSON.parse(raw);
                                } else if (Array.isArray(raw)) {
                                  arrayData = raw;
                                }

                                const parsedOptions: Record<string, string> = {};
                                arrayData.forEach((item) => {
                                  if (item.optionName && item.selectedValue) {
                                    parsedOptions[item.optionName] = item.selectedValue;
                                  }
                                });

                                const priorityKeys = props.item.type === 0
                                  ? ["m²", "Kat Sayısı", "Oda Sayısı"]
                                  : ["Yıl", "KM", "Renk"];

                                const selectedValues: { key: string; value: string }[] = [];

                                // Öncelikli anahtarlar
                                for (const key of priorityKeys) {
                                  const matchedKey = Object.keys(parsedOptions).find((k) => k.includes(key));
                                  if (matchedKey && selectedValues.length < 2) {
                                    selectedValues.push({ key: matchedKey, value: parsedOptions[matchedKey] });
                                  }
                                }

                                // Geriye kalanlar - "Cephe" içeren anahtarları hariç tut
                                if (selectedValues.length < 3) {
                                  for (const [key, value] of Object.entries(parsedOptions)) {
                                    if (!selectedValues.some((v) => v.key === key) &&
                                      selectedValues.length < 2 &&
                                      !key.toLowerCase().includes("cephe")) {
                                      selectedValues.push({ key, value });
                                    }
                                  }
                                }

                                return selectedValues.map((item, index) => (
                                  //bu değil
                                  
                                  <Tag
                                    key={index}
                                    color="#dce8ff"
                                    className={`!m-0  !text-black !text-[10px] md!text-base ${props.viewType === "list"
                                      ? "!w-15 !text-[10px]"
                                      : ""
                                      }`}
                                  >
                                    <Tooltip title={item.key}>
                                      <span className={isBoldFontColored ? "!font-bold" : ""}>
                                        {formatValue(item.key, item.value)}
                                      </span>
                                    </Tooltip>
                                  </Tag>
                                ));
                              } catch (e) {
                                return <Text className="!text-[10px] md:!text-xs text-red-500">Veri hatalı</Text>;
                              }
                            })()}
                          </span>
                        </>
                      );
                    })()}

                    <>
                      {props.pageType === "portfolio" ? (
                        <>
                          {/* Portfolio için özel içerik */}
                        </>
                      ) : (
                        <>
                          {getRelativeDate(props.item.insertDate) <= 30 && (
                            <div
                              className={`absolute z-10 ${props.viewType === "list"
                                ? "!hidden"
                                : "bottom-4 !left-1 md:!left-4"
                                } flex flex-wrap gap-2 max-w-full overflow-hidden`}
                            >
                              {props.item.cardViewAdvertOptions && (
                                <div className="flex flex-wrap gap-2">
                                  <Tag
                                    className="!m-0 !text-black  whitespace-nowrap !text-[10px]"
                                    color="#dce8ff"
                                  >
                                    <span className="!text-[10px] m-2">{location}</span>
                                  </Tag>
                                  <br />
                                  <Tag
                                    className="!m-0 !text-black  whitespace-nowrap !text-[10px]"
                                    color="#dce8ff"
                                  >
                                    <AdvertOptions
                                      options={props.item.cardViewAdvertOptions}
                                      type={props.item.type}
                                      isBoldFontColored={isBoldFontColored}
                                    />
                                  </Tag>
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </>
        ) : (
          <>
            <div
              className="relative w-full min-h-[150px] max-h-[230px] overflow-hidden"
            >
              <LazyLoadImage
                wrapperHeight="100%"
                wrapperWidth="100%"
                src={NoImageSmall}
                imageClassName="no-image w-full h-full"
                alt="Advert"
              />
            </div>
          </>
        )}
        {hasMultipleSlides && !isBeginning && (
          <span
            className={`
              !z-[9999] !absolute ${viewingModes === "cart"
                ? "!top-1/2"
                : ` ${props.pageType === "portfolio"
                  ? "!top-1/4"
                  : "!top-1/3  md:!top-1/3  "
                } `
              } !left-1 md:!left-2 -translate-y-1/2 !w-[22px] !h-[19px]  ${viewingModes === "cart" ? "!ml-1  md:!ml-6 " : "!ml-2 lg:!mt-4 "
              }
  !rounded-full !border !border-white !bg-black   !flex items-center justify-center !cursor-pointer 
   bg-opacity-75 opacity-0 group-hover:opacity-100 group-hover:transition-all duration-300 !text-black
              `}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              swiperRef.current?.swiper.slidePrev();
            }}
          >
            <LeftOutlined className="!text-xs !text-white" />
          </span>
        )}

        {hasMultipleSlides && !isEnd && (
          <span
            className={`!z-[9999] !absolute ${viewingModes === "cart"
              ? "!top-1/2"
              : ` ${props.pageType === "portfolio"
                ? "!top-1/3"
                : "!top-1/3  md:!top-1/3 "
              } `
              } !right-1  md:!right-2 -translate-y-1/2 !w-[22px] !h-[19px]   ${viewingModes === "cart" ? "!mr-1  md:!mr-6 " : "!mr-2 lg:!mt-4"
              }
  !rounded-full !border !border-white !bg-black !flex items-center justify-center !cursor-pointer  
 bg-opacity-75 opacity-0 group-hover:opacity-100 group-hover:transition-all duration-300 !text-black`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              swiperRef.current?.swiper.slideNext();
            }}
          >
            <RightOutlined className="!text-xs !text-white" />
          </span>
        )}
      </div>
    </>
  );
};

export default CardItemCarouselIndex;